"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsUpload',
  inject: {
    ysProviderContext: {
      default: () => ({
        api: {}
      })
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxCount: {
      type: Number,
      default: 1
    },
    listType: {
      type: String,
      default: 'text'
    },
    accept: {
      type: String,
      default: undefined
    },
    uploading: {
      type: Boolean,
      default: false
    },
    defaultFileList: {
      type: Array
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    modelUploading: {
      get() {
        return this.uploading;
      },
      set(value) {
        this.$emit('update:uploading', value);
      }
    }
  },
  watch: {
    modelValue: {
      handler(fileList) {
        if (!fileList.length) {
          return false;
        }
        this.modelUploading = fileList.some(item => {
          return item.status === 'uploading';
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async customRequest({
      file,
      onProgress,
      onSuccess,
      onError
    }) {
      try {
        const res = await this.ysProviderContext.api.upload({
          body: {
            file: file
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onProgress(e) {
            onProgress({
              percent: e.loaded / e.total * 100
            });
          }
        });
        onSuccess(res.link);
      } catch {
        onError();
      }
    },
    handleFileChange({
      fileList
    }) {
      if (this.modelValue.length + fileList.length > this.maxCount) {
        this.modelValue = fileList.slice(-this.maxCount);
        return;
      }
      this.modelValue = fileList;
    }
  }
};